import React, { type FC } from 'react'
import { Box, Paper, type SxProps, Typography } from '@mui/material'

const boxSx: SxProps = {
    display: 'flex',
    gap: 16,
    p: 16,
    maxWidth: '100%',
    overflowX: 'auto',
    backgroundColor: 'white',
}
const paperSx: SxProps = {
    backgroundColor: 'white',
    minWidth: 256,
    height: 240,
    flex: 1,
    my: 3,
    p: 6,
    textAlign: 'center',
    borderRadius: 3,
    borderWidth: 1,
    borderColor: 'grey.300',
    borderStyle: 'solid',
}

const shadowsElevationMap: Record<string, number> = {
    xs: 1,
    sm: 2,
    md: 3,
    lg: 4,
    xl: 5,
    '2xl': 6,
    '3xl': 7,
}

export const Shadows: FC = () => {
    return (
        <Box sx={boxSx}>
            {Object.entries(shadowsElevationMap).map(([label, elevation]) => (
                <Paper elevation={elevation} sx={paperSx} key={elevation}>
                    <Typography variant="subtitle2" fontWeight={500}>
                        shadow-{label}
                    </Typography>
                </Paper>
            ))}
        </Box>
    )
}
